/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
app.Filters = app.Filters || {};
(function ($) {
  'use strict';
  /**
   * Вид для селекта
   */
  app.Filters.SelectFilterView = app.BaseFilterView.extend({
    template: '#select-filter-view',
    selectTemplate: '#select-template',
    events: {
      'click .select-input': 'showPopup',
      'click .scrollable li:not(.disabled)': 'selectFilter',
      'click .js-close-filter-popup': 'hidePopup',
      'change input': 'select'
    },
    run: function (data) {
      this.template = app.helpers.TemplateHelper.getTemplate(this.template);
      this.defaultNameTemplate = app.helpers.TemplateHelper.getTemplate('#select-view-default-name-template');
      if (data.object && data.parent) {
        data.parent.append(
          this.template(data)
        );
        this.setElement(data.parent.find('.filter-select-field:last'));
      }
      this.selectTemplate = app.helpers.TemplateHelper.getTemplate(this.selectTemplate);
      this.selectInput = this.$('#' + data.object.name + '-select');
      this.selectOptions = this.$('.filter-select');
      this.options = data.object.values;
      this.popupOpen = false;
      if (!app.isMobile) {
        this.listenTo(Backbone, 'opened', this.hidePopup);
        this.listenTo(Backbone, 'bodyView:click', this.bodyClick);
      }
      this.render(this.model.get('name'));
    },
    arrowSelectUp: function () {
      this.$('.arrow').addClass('arrow_up').removeClass('arrow_down');
    },
    arrowSelectDown: function () {
      this.$('.arrow').removeClass('arrow_up').addClass('arrow_down');
    },
    /**
     * Отображение блока с опциями.
     */
    showPopup: function (event) {
      this.$(event.currentTarget).blur();
      Backbone.trigger('opened');
      this.popupOpen = true;
      this.selectOptions.find('.popup').removeClass('not_display').addClass('popup-diplayed');
      this.arrowSelectUp();
      this.$('.label').addClass('js-close-filter-popup');
    },
    /**
     * Скрытие блока с опциями.
     */
    hidePopup: function (e) {
      if (e) {
        e.preventDefault();
      }
      if (this.popupOpen) {
        this.selectOptions.find('.popup').addClass('not_display');
        this.arrowSelectDown();
        this.$('.label').removeClass('js-close-filter-popup');
      }
    },
    /**
     * Выбор опции.
     * @param {object} e
     */
    selectFilter: function (e) {
      var target = $(e.target);
      this.selectedFilter = target.text();
      this.selectedId = target.data('select-id');
      if (this.selectedId === undefined) {
        this.selectedId = null;
      }
      this.selectInput.val(this.selectedFilter);
      this.selectInput.trigger('change');
      this.hidePopup();
      this.arrowSelectDown();
    },
    /**
     * Рендеринг опций селекта.
     */
    render: function (name) {
      name = name || this.defaultNameTemplate();
      this.selectInput.val(name);
      this.selectOptions.html(this.selectTemplate({
        options: this.model.get('object').values,
        //на время кэша шаблонов
        obj: this.model.get('object').values,
      }));
    },
    select: function (e) {
      this.model.set('value', this.selectedId);
      this.sendChangeEvent(e);
    }
  });
})(jQuery);

}.call(window));